module.exports = __webpack_public_path__ + "static/media/watch_nav_series_2.a09cbf45.svg";